module.exports = "https://referendum2020-campaigns-cdn.fire-emblem-heroes.com/images/210.9e3cc461.png";